import styled, { css } from 'styled-components'

import theme from 'theme_'
import { BaseText } from './Base'

export const Font12 = css`
  font-size: 12px;
  line-height: 16px;
`

export const Font14 = css`
  font-size: 14px;
  line-height: 16px;
`

export const Font16 = css`
  font-size: 16px;
  line-height: 18px;
`
export const Font18 = css`
  font-size: 18px;
  line-height: 24px;
`
export const Font32 = css`
  font-size: 32px;
  line-height: 48px;
`

export const Secondary = styled(BaseText)`
  font-size: 14px;
  line-height: 20px;
  color: ${(p) => p.color || theme.colors.beachGrey};
`

export const Regular = styled(BaseText)`
  font-size: 14px;
  line-height: ${(p) => p.lh || '1.5'};
  color: ${(p) => p.color || theme.colors.anotherDarkGrey};

  @media ${theme.devices.tablet} {
    font-size: 16px;
  }
`

export const RegularModerate = styled(Regular)`
  line-height: 22px;
`

export const Body12 = styled(BaseText)`
  ${Font12};
  color: ${(p) => p.color || theme.colors.otterWarmBlack};
`

export const Body14 = styled(BaseText)`
  ${Font14};
`

export const Body16 = styled(BaseText)`
  ${Font16};
`

export const BodyPrimary = styled(BaseText)`
  ${Font14};
  color: ${(p) => p.color || theme.colors.moreGrey};
`

export const SectionLabel = styled(BaseText)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  min-height: 30px;
  font-weight: 900;
  ${Font18};
  color: ${theme.colors.otterWarmBlack};
`
